<template>
  <v-container>
    <row-header action="back" :msg="msgRowHeader"></row-header>

    <v-row dense>
      <v-col>
        <v-form
            ref="form"
            v-model="valid"
        >
          <v-card>
            <merchant-form-component :merchant_model="merchant_model" :payment_type="payment_type" update="1" />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  :disabled="!valid"
                  color="success"
                  @click="saveData"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-overlay
        :absolute="absolute"
        :value="overlay"
    >
      <v-card color="white">
        <v-card-text>
          <overlay-img></overlay-img>
        </v-card-text>
      </v-card>
    </v-overlay>

  </v-container>
</template>

<script>
import RowHeader from "../../../components/content/RowHeader";
import OverlayImg from "../../../components/content/OverlayImg";
import MerchantFormComponent from '../../../components/page/merchants/MerchantFormComponent';
import { MerchantData, TypeOfPayment } from '../../../store/services/MerchantModel';
import { PutRequest, GetRequest } from "../../../store/services/users";

export default {
  components: {
    RowHeader,
    OverlayImg,
    MerchantFormComponent,
  },
  data: () => ({
    msgRowHeader: {newUser: 'Back', newMsg: 'Update Merchant'},
    valid: true,
    absolute: false,
    overlay: false,
    merchant_model: new MerchantData(),
    payment_type: new TypeOfPayment(),
  }),
  async mounted() {
    console.log('merchant update view');
    if (this.$store.getters.isLoggedIn) {
      await this.getMerchantData();
    }
  },
  methods: {
    async getMerchantData() {
      await this.$store.dispatch('req_data')
      this.overlay = this.$store.getters.isLoading;
      try {
        const response = await GetRequest('merchants/' + this.$route.params._id);
        delete response.data._id;
        delete response.data.created_at;
        delete response.data.created_by;
        delete response.data.updated_at;
        delete response.data.updated_by;
        delete response.data.__v
        this.merchant_model = response.data;
        await this.$store.dispatch('req_success');
        this.overlay = this.$store.getters.isLoading;
      } catch (e) {
        await this.$store.dispatch('req_failed');
        this.overlay = this.$store.getters.isLoading;
        alert('Get user data failed ' + e.message);
      }
    },
    async saveData() {
      delete this.merchant_model._id;
      delete this.merchant_model.created_at;
      delete this.merchant_model.created_by;
      delete this.merchant_model.active;
      delete this.merchant_model.updated_at;
      delete this.merchant_model.updated_by;
      delete this.merchant_model.__v
      await this.$store.dispatch('req_data')
      this.overlay = this.$store.getters.isLoading;
      try {
        const response = await PutRequest('merchants/' + this.$route.params._id, this.merchant_model);
        await this.$store.dispatch('req_success');
        this.overlay = this.$store.getters.isLoading;
        if (response.data && response.message === 'updated') {
          alert('success to updated data');
          await this.$router.push({name: 'MerchantList'});
        } else {
          alert('failed to updated data');
        }
      } catch (e) {
        await this.$store.dispatch('req_failed');
        this.overlay = this.$store.getters.isLoading;
        alert('Get user data failed ' + e.message);
      }
    },
  }
}
</script>

<style scoped>

</style>
